export default __webpack_public_path__ + "static/media/calendar-already-connected.5e8fa90a.svg";